
// Helper functions for grouping notes

export function groupNotesByDate(notes) {
    const today = [];
    const yesterday = [];
    const thisWeek = [];
    const thisMonth = [];
    const older = [];

    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterdayStart = new Date(todayStart.getTime() - 24 * 60 * 60 * 1000);
    const weekStart = new Date(todayStart.getTime() - 7 * 24 * 60 * 60 * 1000);
    const monthStart = new Date(todayStart.getTime() - 30 * 24 * 60 * 60 * 1000);

    notes.forEach(note => {
        // Handle both Firestore Timestamp and JS Date objects
        const date = note.updatedAt?.toDate ? note.updatedAt.toDate() : new Date(note.updatedAt || Date.now());

        if (date >= todayStart) {
            today.push(note);
        } else if (date >= yesterdayStart) {
            yesterday.push(note);
        } else if (date >= weekStart) {
            thisWeek.push(note);
        } else if (date >= monthStart) {
            thisMonth.push(note);
        } else {
            older.push(note);
        }
    });

    return { today, yesterday, thisWeek, thisMonth, older };
}

export function groupNotesByDomain(notes) {
    const byDomain = {};

    notes.forEach(note => {
        const domain = note.domain || 'Unknown';
        if (!byDomain[domain]) {
            byDomain[domain] = [];
        }
        byDomain[domain].push(note);
    });

    // Sort domains alphabetically, sort notes within each by date desc
    const sortedDomains = Object.keys(byDomain).sort();
    const result = {};

    sortedDomains.forEach(domain => {
        result[domain] = byDomain[domain].sort((a, b) => {
            const dateA = a.updatedAt?.toDate ? a.updatedAt.toDate() : new Date(a.updatedAt || 0);
            const dateB = b.updatedAt?.toDate ? b.updatedAt.toDate() : new Date(b.updatedAt || 0);
            return dateB - dateA;
        });
    });

    return result;
}
